import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatCard, MatCardContent } from '@angular/material/card';

import { AccountData } from '@common/data';

import { SessionService, TermsStatusService } from '@app/core';
import { TermsService } from '@app/terms/services';

import { TermsDisplayComponent } from '../../../components/terms-display/terms-display.component';


@Component({
    templateUrl: './usd-pad-terms.component.html',
    styleUrls: ['./usd-pad-terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatCard,
        MatCardContent,
        TermsDisplayComponent,
    ],
})
export class UsdPadTermsComponent {
  private _accountData = inject(AccountData);
  private _sessionService = inject(SessionService);
  private _termsStatusService = inject(TermsStatusService);
  private _termsService = inject(TermsService);


  public get skippable(): boolean {
    return this._termsStatusService.snapshot()?.usdPad?.skippable ?? false;
  }

  public submit() {
    this._accountData.acceptTerms(this._sessionService.account().id, {
      usdPadTermsAccepted: true,
    })
      .subscribe(({ terms }) => {
        this._termsStatusService.setSnapshot(terms, this._sessionService.account().id);
        this._termsService.continueTermsFlow();
      });
  }

  public skip() {
    this._termsService.skipTerm('usdPad');
  }

}
